import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionWrapper, FadeIn } from './Shared';
export const Modules = () => {
  const modules = [{
    icon: '📗',
    title: 'MÓDULO I – Entendé tu hinchazón',
    desc: 'Descubrí por qué tu cuerpo se inflama y qué la está provocando realmente.',
    points: ['Tipos de hinchazón (no todas son iguales)', 'Errores comunes que la empeoran', 'Señales que tu cuerpo ya te está dando', 'Cómo identificar tu caso específico']
  }, {
    icon: '📕',
    title: 'MÓDULO II – Alimentación sin inflamación',
    desc: 'No es dieta. Es entender qué te hincha y qué no.',
    points: ['Alimentos que desinflaman de verdad', 'Combinaciones que evitás sin darte cuenta', 'Errores “saludables” que generan hinchazón', 'Cómo armar comidas simples sin inflamarte']
  }, {
    icon: '📙',
    title: 'MÓDULO III – Sistema diario anti-hinchazón',
    desc: 'Una rutina práctica que podés aplicar todos los días.',
    points: ['Rutina de mañana para desinflamar', 'Hábitos clave durante el día', 'Qué hacer después de comer', 'Cómo evitar la hinchazón nocturna']
  }, {
    icon: '📓',
    title: 'MÓDULO IV – Regulación digestiva real',
    desc: 'El problema no es solo lo que comés, sino cómo lo procesás.',
    points: ['Cómo mejorar tu digestión naturalmente', 'Señales de digestión lenta', 'Estrategias para desinflamar rápido', 'Ajustes simples que cambian todo']
  }, {
    icon: '📔',
    title: 'MÓDULO V – Estrés, hormonas y hinchazón',
    desc: 'La parte que nadie te explica.',
    points: ['Cómo el estrés impacta en tu abdomen', 'Hinchazón hormonal (y cómo manejarla)', 'Señales internas que ignorás', 'Regulación emocional aplicada al cuerpo']
  }, {
    icon: '📒',
    title: 'MÓDULO VI – Plan práctico de transformación',
    desc: 'Pasás de entender → aplicar → ver resultados.',
    points: ['Plan de acción paso a paso', 'Checklist diario simple', 'Seguimiento de cambios', 'Cómo sostener resultados sin recaer']
  }];
  return <SectionWrapper className="bg-white" data-id="element-96">
      <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-97">
        <FadeIn data-id="element-98">
          <span className="text-4xl mb-4 block" data-id="element-99">📘</span>
          <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4" data-id="element-100">
            ¿Qué incluye DESHINCHATE?
          </h2>
          <p className="text-xl text-slate-600 font-serif italic" data-id="element-101">
            Un sistema completo, claro y aplicable desde el primer día.
          </p>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-102">
        {modules.map((mod, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-103">
            <div className="h-full bg-cream rounded-2xl md:rounded-3xl p-5 md:p-8 border border-sage-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-104">
              <div className="text-3xl mb-4" data-id="element-105">{mod.icon}</div>
              <h3 className="text-xl font-bold text-sage-900 mb-3 leading-tight" data-id="element-106">
                {mod.title}
              </h3>
              <p className="text-slate-600 mb-6 text-sm" data-id="element-107">{mod.desc}</p>
              <ul className="space-y-3" data-id="element-108">
                {mod.points.map((point, i) => <li key={i} className="flex items-start space-x-3" data-id="element-109">
                    <CheckIcon className="w-5 h-5 text-sage-500 flex-shrink-0 mt-0.5" data-id="element-110" />
                    <span className="text-slate-700 text-sm leading-snug" data-id="element-111">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>)}
      </div>
    </SectionWrapper>;
};